<template>
  <section class="content-page">

    <!-- HEADER -->
    <header class="header" >
      <div>
        <h2>My Influencers</h2>
        <p class="subtitle">
          Exclusive updates from influencers you follow
        </p>
      </div>
    </header>

    <section class="controls" v-if="posts.length">

        <input
          v-model="filters.search"
          type="text"
          placeholder="Search influencers..."
        
        />

      </section>
   

    <!-- EMPTY STATE -->
     <div v-if="!posts.length" class="empty">
      <div class="empty-box">

        <div class="empty-icon">
          <i class='bx bx-search-alt'></i>
        </div>

        <h3>No content yet</h3>

        <p>
          You’ll see posts from influencers you follow here.
        </p>

        <button @click="loadFeed()" class="empty-btn">
          Refresh
        </button>

      </div>
    </div>

    <!-- CONTENT GRID -->
    <section v-else class="grid">
      <article
        v-for="p in posts"
        :key="p.id"
        class="post"
      >
        <!-- POST HEADER -->
        <div class="post-header">
          <div class="avatar">
            {{ p.creator.charAt(0) }}
          </div>

          <div class="meta">
            <h4>{{ p.creator }}</h4>
            <span>{{ p.date }}</span>
          </div>

        </div>

        <!-- POST BODY -->
        <div class="post-body">
          <p class="text">{{ p.text }}</p>

          <img
            v-if="p.image"
            :src="p.image"
            alt="Post image"
          />
        </div>

        <div class="post-actions">
          <button @click="viewPost(p)">
            View
          </button>
        </div>
      </article>
    </section>

    <!-- PAGINATION -->
    <section v-if="totalPages > 1" class="pagination">
      <button :disabled="page === 1" @click="page--">
        Prev
      </button>

      <span>
        Page {{ page }} of {{ totalPages }}
      </span>

      <button :disabled="page === totalPages" @click="page++">
        Next
      </button>
    </section>

  </section>
</template>
<script>
import { getFanFeed } from "../apis/fanconapis";

export default {
  name: "FanContent",

  data() {
    return {
      page_no: 0,

      filters: {
        search: "",
        creator: ""
      },

      posts: [],
      total: 0,
      loading: false,
      user_id:""
    };
  },

  computed: {
    creators() {
      return [...new Set(this.posts.map(p => p.creator))];
    },

    totalPages() {
      return Math.ceil(this.total / 10); // backend page size = 8
    }
  },

  watch: {
    page_no() {
      this.loadFeed();
    },
    "filters.search": function () {
    clearTimeout(this._searchTimer);

    this._searchTimer = setTimeout(() => {
      this.page_no = 0;
      this.loadFeed();
    }, 400);
  },
    filters: {
      deep: true,
      handler() {
        this.page_no = 0;
        this.loadFeed();
      }
    }
  },

  mounted() {
    const ldataRaw = sessionStorage.getItem("ldata");
      const ldata = ldataRaw ? JSON.parse(ldataRaw) : null;
      if(ldata!=null){
        this.user_id = ldata.user_id;
        this.loadFeed();
      }
    
  },
  
  methods: {
    viewPost(p){
      window.location.href = "/influencer/"+p.owner;
    },
    async loadFeed() {

      this.loading = true;

      const res = await getFanFeed({
        user_id: this.user_id,
        page_no: this.page_no,
        search: this.filters.search,
        creator: this.filters.creator
      });

      if (res.status) {

        this.posts = (res.records || []).map(p => ({
          id: p.fcontent_id ?? p.follower_id,
          creator: p.user_name ?? "Creator",
          date: this.formatDate(
            p.fcontent_created_at ?? 
            p.follower_created_at
          ),
          text: p.fcontent_text ?? "",
          image: p.fcontent_media ?? null,
          owner: p.follower_influencer ?? null
        }));

        this.total = res.total || 0;
      }

      this.loading = false;
    },

    formatDate(date) {

      if (!date) return "";

      return new Date(date).toLocaleDateString("en-IN", {
        day: "numeric",
        month: "short",
        year: "numeric"
      });
    },

    nextPage() {
      if (this.page_no + 1 < (this.total/10)) {
        this.page_no++;
      }
    },

    prevPage() {
      if (this.page_no > 0) {
        this.page_no--;
      }
    }
  }
};
</script>

<style scoped>
.content-page {
  max-width: 1440px;
  margin: auto;
  padding: 48px;
}

/* HEADER */
.header {
  margin-bottom: 24px;
}

.subtitle {
  color: #64748b;
  margin-top: 6px;
}

/* CONTROLS */
.controls {
  display: flex;
  gap: 12px;
  width: 20rem;
  margin-bottom: 32px;
}

.controls input,
.controls select {
  flex: 1;
  
  padding: 12px 14px;
  border-radius: 14px;
  background: #f8fafc;
  font-weight: 600;
}

/* EMPTY */
.empty {
  margin-top: 80px;
  text-align: center;
  color: #64748b;
}

/* GRID */
.grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

/* POST */
.post {
  background: white;
  border-radius: 20px;
  padding: 20px;
  border: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
}

/* POST HEADER */
.post-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #0f172a;
  color: white;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
}

.meta h4 {
  font-weight: 800;
}

.meta span {
  font-size: 12px;
  color: #64748b;
}

.badge {
  margin-left: auto;
  background: #f1f5f9;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
}

/* POST BODY */
.post-body .text {
  font-size: 14px;
  line-height: 1.6;
}

.post-body img {
  width: 100%;
  border-radius: 12px;
  margin-top: 12px;
}

/* PAGINATION */
.pagination {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  gap: 16px;
  align-items: center;
}

.pagination button {
  padding: 8px 14px;
  border-radius: 12px;
  font-weight: 800;
  background: #f1f5f9;
}

/* RESPONSIVE */
@media (max-width: 1200px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .grid {
    grid-template-columns: 1fr;
  }
}

/* ===============================
   FAN CONTENT – MOBILE PATCH
   =============================== */
@media (max-width: 640px) {

  /* Page padding */
  .content-page {
    padding: 20px 16px 72px;
  }

  /* Header */
  .header h2 {
    font-size: 24px;
    line-height: 1.2;
  }

  .subtitle {
    font-size: 14px;
  }

  /* Controls → stacked */
  .controls {
    flex-direction: column;
    gap: 10px;
    margin-bottom: 20px;
  }


  /* Empty state */
  .empty {
    margin-top: 48px;
  }

  .empty h3 {
    font-size: 18px;
  }

  .empty p {
    font-size: 14px;
  }

  /* Post card */
  .post {
    padding: 16px;
    border-radius: 16px;
  }

  /* Post header */
  .post-header {
    gap: 10px;
  }

  .avatar {
    width: 36px;
    height: 36px;
    font-size: 14px;
  }

  .meta h4 {
    font-size: 14px;
  }

  .meta span {
    font-size: 11px;
  }

  .badge {
    font-size: 10px;
    padding: 4px 8px;
  }

  /* Post body */
  .post-body .text {
    font-size: 14px;
    line-height: 1.55;
  }

  .post-body img {
    margin-top: 10px;
    border-radius: 10px;
  }

  /* Pagination */
  .pagination {
    margin-top: 28px;
    justify-content: space-between;
  }

  .pagination span {
    font-size: 13px;
    font-weight: 700;
  }

  .pagination button {
    padding: 10px 14px;
    font-size: 13px;
  }
}
.post-actions {
  margin-top: auto;
  padding-top: 12px;
  display: flex;
  justify-content: flex-end;
}

.post-actions button {
  padding: 8px 14px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 800;
  background: #0f172a;
  color: white;
  transition: 0.2s ease;
}

.post-actions button:hover {
  opacity: 0.85;
}

/* ===============================
EMPTY STATE – PREMIUM
=============================== */

.empty {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 80px;
}

/* glass card */
.empty-box {
  max-width: 420px;
  text-align: center;
  padding: 36px 28px;
  border-radius: 20px;

  background: rgba(255,255,255,0.7);
  backdrop-filter: blur(12px);

  border: 1px solid rgba(226,232,240,0.8);
  box-shadow: 0 10px 30px rgba(0,0,0,0.05);
}

/* icon */
.empty-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 16px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;

  background: linear-gradient(135deg, #0f172a, #1e293b);
  color: white;
}

.empty-icon i {
  font-size: 26px;
}

/* title */
.empty-box h3 {
  font-size: 18px;
  font-weight: 800;
  margin-bottom: 6px;
}

/* text */
.empty-box p {
  font-size: 13px;
  color: #64748b;
  line-height: 1.6;
}

/* button */
.empty-btn {
  margin-top: 18px;
  padding: 10px 18px;
  border-radius: 12px;

  background: #0f172a;
  color: white;

  font-size: 13px;
  font-weight: 700;

  transition: all 0.2s ease;
}

.empty-btn:hover {
  transform: translateY(-1px);
  opacity: 0.9;
}

/* mobile */
@media (max-width: 640px) {
  .empty-box {
    padding: 28px 20px;
  }

  .empty-icon {
    width: 54px;
    height: 54px;
  }

  .empty-icon i {
    font-size: 22px;
  }
}
</style>
